<template>
  <el-config-provider :locale="elementLocale">
    <router-view />
  </el-config-provider>
</template>

<script setup>
import { computed, watchEffect } from "vue";
import { useRoute } from "vue-router";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import en from "element-plus/es/locale/lang/en";
import { locale, t } from "./i18n";

const elementLocale = computed(() => locale.value === "en-US" ? en : zhCn);
const route = useRoute();
const legalTitles = { agreement: "ALLFO 用户协议", paidServiceAgreement: "ALLFO 付费服务协议", privacy: "ALLFO 隐私政策" };
watchEffect(() => {
  document.documentElement.lang = locale.value;
  document.title = t(legalTitles[route.meta.legalDocument] || route.meta.title || "Allfo 用户工作台");
});
</script>
